import { render, staticRenderFns } from "./app-android.vue?vue&type=template&id=1b12fa0a&scoped=true"
import script from "./app-android.vue?vue&type=script&lang=js"
export * from "./app-android.vue?vue&type=script&lang=js"
import style0 from "./app-android.vue?vue&type=style&index=0&id=1b12fa0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b12fa0a",
  null
  
)

export default component.exports